module.exports = __webpack_public_path__ + "img/bgtop.bak.9bf32ec6.jpg";